import React from 'react';
import api from './../../../services/api';
import { user_token } from '../../../services/Auth';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);
var medico_id = localStorage.getItem("professional_id");

export default class GetExam extends React.Component {
  state = {
    professional: []
  }

  componentDidMount() {
    //console.log("Essa id é do maluco:" + medico_id);
    apiProfessional.getProfessional(medico_id)
      //api.get(`/professional/${medico_id}`, {headers: {'x-access-token': token}})
      .then(res => {
        const professional = res.data;
        this.setState({ professional });
      })
  }

  render() {
    return (
      <ul>
        {this.state.professional.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Médico(a): </p><p>{details.name}</p>
            <p id="RI-Title-Cadastro-Paciente" >Número do Conselho Profissional: </p><p>{details.crm}</p>
            <p id="RI-Title-Cadastro-Paciente" >Área: </p><p>{details.occupation_area}</p>
            <p id="RI-Title-Cadastro-Paciente" >Especialidade: </p><p>{details.medical_specialty}</p>
            <p id="RI-Title-Cadastro-Paciente" >Email: </p><p>{details.email}</p>
          </>)}
      </ul>
    )
  }
}